<template>
  <div :class="classes">
    <pt-page-title :title="(isEdit?'编辑':'新建')+'新闻'" class="news-form-title"></pt-page-title>
    <div :class="$style['publish-news-message']">
      <table :class="$style['publish-news-table']">
        <pt-form-list-item label="新闻标题：" required>
          <wt-input v-model="formValue.title" :class="$style['news-title']" data-vv-as="新闻标题" name="title"
            v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="作者：">
          <wt-input v-model="formValue.author" :class="$style['news-title']"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="来源：" required>
          <wt-input v-model="formValue.from" :class="$style['news-title']" data-vv-as="来源" name="title"
            v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="新闻分类：" required>
          <wt-selector :options="newsCategories" :props="newsCategoriesProps" v-model="formValue.categoryId"
            data-vv-as="分类" name="title" v-validate="'required'"></wt-selector>
        </pt-form-list-item>
        <pt-form-list-item label="在工具中心展示：" required>
          <el-switch v-model="formValue.toolsCenterVisible"></el-switch>
        </pt-form-list-item>
        <pt-form-list-item label="在活动中心展示：" required>
          <el-switch v-model="formValue.actionCenterVisible"></el-switch>
        </pt-form-list-item>
        <pt-form-list-item label="新闻封面：" required>
          <template>
            <wt-upload-file :action="uploadApi" :class="$style['news-banner-pictrue-upload']" class="news-banner-pictrue-upload" :data="picture_params"
            :img-url="privateResourcesUrl" :multiple="false" v-model="formValue.mainPicture" data-vv-as="新闻封面"
            name="title" v-validate="'required'">
            <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
          </wt-upload-file>
            <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：301*255像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <pt-form-list-item label="活动中心展示banner：" required>
          <template>
            <wt-upload-file :action="uploadApi" :class="$style['activity-banner-pictrue-upload']" class="activity-banner-pictrue-upload" :data="picture_params"
            :img-url="privateResourcesUrl" :multiple="false" v-model="formValue.bannerURL" data-vv-as="活动中心展示banner"
            name="title" v-validate="'required'">
            <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
          </wt-upload-file>
            <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：340*140像素；建议分辨率：120dpi；图片格式：.jpg、.png</div>
            </template>
        </pt-form-list-item>
        <pt-form-list-item label="新闻摘要：" required>
          <wt-input type="textarea" :autosize="{ minRows: 5, maxRows:8}" :class="$style['news-description']"
            v-model="formValue.digest" data-vv-as="新闻摘要" name="title" v-validate="'required'"></wt-input>
        </pt-form-list-item>
      </table>
      <div style="color:red">如果需要插入商品链接，请前往商品详情页面复制</div>
      <div style="color:red">如果需要插入优惠券领取链接，请前往优惠券详情页面复制</div>
      <wt-ueditor resource="news" ref="ueditor" v-model="formValue.content" :content="content"></wt-ueditor>
      <!-- <wt-simditor-textarea :class="$style['news-detail']" :content="content" :publicImageUrl="privateResourcesUrl"
        :fileUploadUrl="fileUploadUrlKey" :params="picture_params_sim" v-model="formValue.content">
      </wt-simditor-textarea> -->
    </div>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-news-form'

export default {
  name: 'pt-news-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    newsDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    newsCategories: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      formValue: {
        toolsCenterVisible: true
      },
      privateResourcesUrl: this.$publicResourcesUrl,
      fileUploadUrlKey: this.$uploadApiKey,
      picture_params_sim: {
        resourceName: 'news',
        objectId: this.id || 0,
        key: 'file_path'
      },
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'news',
        objectId: this.id || 0
      },
      newsCategoriesProps: {
        label: 'name',
        value: 'id'
      }
    }
  },
  watch: {
    newsDetail: {
      handler: function (val) {
        this.formValue = val
      }
    }
  },
  methods: {
    // 获取富文本内容
    // getEdiotrContent () {
    //   let content = this.$refs.ueditor.getUEContent() // 调用子组件方法
    //   this.formValue.content = content
    // }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .publish-news-table {
    padding: 20px 0 0;
  }

  .sort{
    padding: 0 .2rem
  }
  .publish-news-message {
    // padding: 0 20px
    max-width: 1000PX
  }

  .news-title {
    max-width: 300PX;
  }

  .news-description {
    width: 350Px
  }

  .news-detail {
    max-height: 80vh;
    display: flex;
    position: relative;
    overflow-y: hidden;
    :global
    .simditor-textarea{
        display: flex;
        .simditor{
            display: flex;
            .simditor-wrapper{
                .simditor-body{
                    height:  calc(100% - 120px);
                    overflow-y: auto;
                     img{
                        max-width: 100%;
                    }
                }
            }
        }
    }
  }
</style>
<style lang="less">
  .pt-news-form {
    .news-form-title {
      margin-bottom: 0
    }
  }
  .news-banner-pictrue-upload{
    .el-upload--picture-card{
        width: 301px;
        height: 255px;
        display:inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
        box-sizing:inherit
    }
  }
  .activity-banner-pictrue-upload{
    .el-upload--picture-card{
        width: 340px;
        height: 140px;
        display:inline-flex;
        align-items: center;
        justify-content: center;
    }
    .el-upload-list__item{
        .el-upload--picture-card;
        box-sizing:inherit
    }
  }
</style>
